<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconshenhe"></i>
      机构数据
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-input
              v-model="org_name"
              placeholder="请输入机构名称"
              class="margin-right-sm"
          ></el-input>
          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>
      </div>
      <el-table
          :data="orgList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          fit
          style="width: 100%"
      >

        <el-table-column label="机构名称">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.org_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="班级数">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.classNum  }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="在校学生总数">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.schoolNum  }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="在校学习学生数">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.studentNum  }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="实习学生数">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.shixiNum  }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <div class="table-item flex justify-around">
              <router-link :to="'/coordinate/room?id=' + scope.row.org_id">
                <el-button type="primary" >
                  班级数据
                </el-button>
              </router-link>
              <router-link :to="'/coordinate/student?id=' + scope.row.org_id">
                <el-button type="primary">
                  学生数据
                </el-button>
              </router-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          v-if="orgList.length > 0"
          class="page-all"
          background
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { xieSchoolList} from "@/api/coordinate";

export default {
  name: "organ5",
  data() {
    return {
      orgList:[],
      page: 1,
      total: 0,
      limit: 10,
      org_name:'',
    };
  },
  created() {
    this.$emit(
        "setIndex",
        this.$route.path,
        "当前位置：机构数据",
        false
    );
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page)
      this.org_name = this.$route.query.org_name
    }
    this.getList();
  },
  methods: {
    async getList() {
      let _list = await xieSchoolList(
          this.page,
          this.limit,
          this.org_name
      );
      this.orgList = _list.data.list;
      this.total = _list.data.count;
    },
    //  修改路径
    setPath() {
      this.$router.push({
        path: '/coordinate/verify2',
        query: {
          page: this.page,
          exam_name: this.exam_name
        }
      })
    },
    onSearch() {
      if (this.page === 1) {
        this.setPath()
      } else {
        this.page = 1;
      }
    },
  },
  watch: {
    page() {
      this.setPath()
    },
    $route() {
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">

</style>